import { ToastContainer } from 'react-toastify';
import { AuthProvider } from '@contexts/auth';
import { UserProfileProvider } from '@contexts/userProfile';
import { BrowserRouter } from "react-router";
import ChakraProvider from '@components/ChakraProvider'

import AppRoutes from './router';
import ErrorBoundary from './ErrorBoundary';
import Maintance from './Maintance';
import './datadogRUM-init';

const App = () => {
  if (import.meta.env.VITE_MAINTANCE_MODE === 'true') {
    return (
      <ChakraProvider>
        <Maintance />
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider>
      <ErrorBoundary>
        <AuthProvider>
          <UserProfileProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
            <ToastContainer />
          </UserProfileProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ChakraProvider>
  );
};

export default App;
